<div class="call-users-card">
  <div class="card-header">
    <h3>{{ 'CALL_SETUP.CALL_USERS.TITLE' | translate }}</h3>
    <p>{{ 'CALL_SETUP.CALL_USERS.DESCRIPTION' | translate }}</p>
  </div>

  <ul class="call-users">
    @for (user of call.users; track user.id) {
      <li class="call-user">
        <app-avatar [input]="user | userName" size="small"></app-avatar>
        <div class="identity">
          <span class="name">
            {{ user | userName }}
            @if (user.id === currentUserId) {
              <span class="you">({{ 'CALL_SETUP.CALL_USERS.YOU' | translate }})</span>
            }
          </span>
          <span class="email">{{ user.email }}</span>
        </div>
        @if (canManage && user.id !== currentUserId) {
          <span [matTooltip]="isLastCallUser ? ('CALL_SETUP.CALL_USERS.LAST_CALL_USER' | translate) : ''">
            <button
              mat-icon-button
              class="remove-button"
              [attr.aria-label]="'CALL_SETUP.CALL_USERS.REMOVE' | translate: { userName: user | userName }"
              [matTooltip]="isLastCallUser ? '' : ('CALL_SETUP.CALL_USERS.REMOVE' | translate: { userName: user | userName })"
              [disabled]="isLastCallUser || (removeCallUserMutation.result$ | async)?.isPending"
              (click)="removeCallUser(user)"
            >
              <mat-icon>person_remove</mat-icon>
            </button>
          </span>
        }
      </li>
    }
  </ul>

  @if (canManage) {
    @if (organizationUsers$ | async; as organizationUsers) {
      <div class="add-call-user-row">
        <mat-form-field appearance="outline" class="user-input" subscriptSizing="dynamic">
          <mat-label>{{ 'CALL_SETUP.CALL_USERS.ADD_PLACEHOLDER' | translate }}</mat-label>
          <input matInput name="call-user" autocomplete="off" [(ngModel)]="filter" [matAutocomplete]="auto" />
          <mat-autocomplete #auto="matAutocomplete">
            @for (user of addableUsers(organizationUsers); track user.id) {
              <mat-option [value]="describeUser(user)">{{ describeUser(user) }}</mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
        <button
          mat-stroked-button
          type="button"
          [disabled]="selectedUser(organizationUsers) === null || (addCallUserMutation.result$ | async)?.isPending"
          (click)="addCallUser(selectedUser(organizationUsers))"
        >
          {{ 'COMMON.ADD' | translate }}
        </button>
      </div>
    }
  }
</div>
